import { render, staticRenderFns } from "./LidBox.vue?vue&type=template&id=44e182d7&"
import script from "./LidBox.vue?vue&type=script&lang=js&"
export * from "./LidBox.vue?vue&type=script&lang=js&"
import style0 from "./LidBox.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports